import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AppConfigService } from '../services/app-config.service';
import { InterceptorHelperService } from '../services/interceptor-helper.service';
import { RouterFacadeService } from '../store/router/router-facade.service';

@Injectable()
export class RequestContextAdminViewInterceptor implements HttpInterceptor {
  private _interceptorHelperService = inject(InterceptorHelperService);
  private readonly _BASE_URL = inject(AppConfigService).appConfig.azure.proxy_base_url;
  private _routerFacadeService = inject(RouterFacadeService);

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    if (!request.url.includes(this._BASE_URL) || request.headers.has('CV-Request-Context')) {
      return next.handle(request);
    }

    const requestParamsTenantId = request.params.get('organisationId');
    const requestParamsBoardId = request.params.get('boardId');
    const routerTenantId = this._routerFacadeService.tenantId();
    const routerBoardId = this._routerFacadeService.boardId();
    const interceptorHelperTenantId = this._interceptorHelperService.selectedTenantId();
    const interceptorHelperBoardId = this._interceptorHelperService.selectedBoardId();
    const interceptorHelperServiceProviderId = this._interceptorHelperService.selectedServiceProviderId();

    const tenantId = requestParamsTenantId || routerTenantId || interceptorHelperTenantId;
    const boardId = requestParamsBoardId || routerBoardId || interceptorHelperBoardId;
    const serviceProviderId = interceptorHelperServiceProviderId;

    const tenantIdForHeader = tenantId?.replace(/-/g, '') || '*';
    const boardIdForHeader = boardId?.replace(/-/g, '') || '*';
    const serviceProviderIdForHeader = serviceProviderId?.replace(/-/g, '') || '*';

    const headerValue = `01-${serviceProviderIdForHeader}-${tenantIdForHeader}-${boardIdForHeader}-*-*`;

    const modifiedRequest = request.clone({
      setHeaders: { 'CV-Request-Context': headerValue },
    });

    return next.handle(modifiedRequest);
  }
}
